export default __webpack_public_path__ + "static/FTRegolaNeue-Regular-326be96419a6f6b82c7edb9aa74f0de1.woff2";